import type { FieldIssueParams } from './FieldIssueParams'

const number = (params: FieldIssueParams | undefined, name: string): number | undefined => {
  const value = params?.[name]
  return typeof value === 'number' ? value : undefined
}

const text = (params: FieldIssueParams | undefined, name: string): string | undefined => {
  const value = params?.[name]
  return typeof value === 'string' ? value : undefined
}

const list = (params: FieldIssueParams | undefined, name: string): readonly string[] => {
  const value = params?.[name]
  return Array.isArray(value) ? value : []
}

const flag = (params: FieldIssueParams | undefined, name: string): boolean =>
  params?.[name] === true

/** Typed reads of a field issue's wire params; an absent or mistyped param reads as undefined, an empty list, or false. */
export const readFieldIssueParam = Object.freeze({ flag, list, number, text })
